// src/plugins/types.ts
// Typed surface for plugin manifests, permissions, and runtime state.
// This file intentionally has zero runtime deps so it can be imported anywhere.
export class PluginPermissionError extends Error {
    pluginId;
    permission;
    code = 'plugin_permission_denied';
    constructor(pluginId, permission) {
        super(`Plugin "${pluginId}" tried to use "${permission}" but that permission isn't in its manifest. ` +
            `Open its page in Plugins, review what it needs, and re-install to grant access.`);
        this.pluginId = pluginId;
        this.permission = permission;
    }
}
export class PluginNotFoundError extends Error {
    code = 'plugin_not_found';
    constructor(id) { super(`Plugin "${id}" is not installed.`); }
}
